<template lang='slm'>
  div
    .section.question
      .container.pt-4.pb-4
        h2 Задать вопрос анонимно
        template v-if='link'
          h3 Вы сможете получить доступ к ответу по этой ссылке:
          input.form-control type='text' readonly='' v-model='link'
          button.btn.btn-secondary.mt-3 type='button' @click='reset()' Задать ещё один вопрос
        template v-else=''
          form @submit.prevent='submitForm()'
            .form-group
              label Как к вам обращаться?
              input.form-control type='text' v-model='name' placeholder='Вы можете указать любое имя'
            .form-group
              label Ваш вопрос
              textarea.form-control placeholder='Напишите ваш вопрос здесь' v-model='question'
            button.btn.btn-primary :disabled='!canSubmit'
              icon.mr-2 v-show='submitting' name='spinner' :spin='true'
              span Задать вопрос
            small.d-block После нажатия на кнопку вы получите ссылку, по которой вы сможете увидеть ответ на ваш вопрос
</template>

<style lang='stylus' scoped>
#main
  background-color white
.question
  text-align left
</style>

<!-- FIXME Добавить капчу -->

<script>
import gql from 'graphql-tag';

export default {
  name: 'QuestionPage',
  data() {
    return {
      name: '',
      question: '',
      submitting: false,
      link: '',
    };
  },
  methods: {
    async submitForm() {
      this.submitting = true;
      const resp = await this.$apollo.mutate({
        mutation: gql`mutation AskQuestion($name: String!, $question: String!, $prev: String) { askQuestion(name: $name, question: $question, previousQuestionLink: $prev) }`,
        variables: {
          name: this.name,
          question: this.question,
          prev: this.$route.query.prev,
        },
      });
      this.submitting = false;
      this.link = `${document.location.origin}/question/${resp.data.askQuestion}`;
    },
    reset() {
      this.name = '';
      this.question = '';
      this.submitting = false;
      this.link = '';
    },
  },
  computed: {
    canSubmit() {
      return this.name && this.question && !this.submitting;
    },
  },
  created() {
    this.reset();
  },
};
</script>
